import axios from "axios";
import { baseUrl } from "../util";

export const getEmissionGassesTotal = ({
  businessId,
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryGasses = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/emissions-gasses",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryGasses(response.data.total_obj.systemboundary_category);
    })
    .catch(function (error) {
      console.log(error);
    });
};
